import React, { Component } from 'react'

import { MaskInput } from './MaskInput/MaskInput'
import { IProps, SimpleInput } from './SimpleInput'

export class Input extends Component<IProps> {
  render(): JSX.Element {
    if (this.props.mask) {
      return <MaskInput {...this.props} />
    }

    return <SimpleInput {...this.props} />
  }
}
